import React from 'react';
import { AttachmentCategoryCell } from '../components/AttachmentCategoryCell';
import { AttachmentVisibilityCell } from '../components/AttachmentVisibilityCell';
/** `dataKey`s these two columns sort on, handed to the surface as `entitySortableColumns`. */
export const BUILDING_SORTABLE_COLUMNS = ['categoryLabel', 'visibilitySortKey'];
/**
 * Building's own two columns — Category and Visible to — inserted by the shared surface between
 * Name and Type. Everything else in that table (preview, name, type, uploaded, size, delete) is
 * the surface's, identical across every attachment screen.
 *
 * `Visible to` points `dataKey` at `visibilitySortKey` because its display differs from its sort
 * value; the surface's own Size/Uploaded columns do the same thing for the same reason.
 */
export function buildBuildingColumns({ translateFn, buildingId, categoryOptions, addCategoryLabel, onRequestAddCategory, showPortalVisibilityOption }) {
    return [
        {
            dataKey: 'categoryLabel',
            label: translateFn('columns.category'),
            width: '180px',
            renderer: ({ item }) => (React.createElement(AttachmentCategoryCell, { item: item, buildingId: buildingId, options: categoryOptions, addCategoryLabel: addCategoryLabel, onRequestAddCategory: onRequestAddCategory }))
        },
        {
            dataKey: 'visibilitySortKey',
            label: translateFn('columns.visible_to'),
            width: '180px',
            renderer: ({ item }) => (React.createElement(AttachmentVisibilityCell, { item: item, buildingId: buildingId, showPortalOption: showPortalVisibilityOption, translateFn: translateFn }))
        }
    ];
}
